import { ref, computed } from 'vue';
import type { User, Session } from '@supabase/supabase-js';
import { supabase } from '../lib/supabase';

// Module-level singleton — shared across all views
const user    = ref<User | null>(null);
const session = ref<Session | null>(null);
const ready   = ref(false);

supabase.auth.getSession().then(({ data }) => {
  session.value = data.session;
  user.value    = data.session?.user ?? null;
  ready.value   = true;
});

supabase.auth.onAuthStateChange((_event, s) => {
  session.value = s;
  user.value    = s?.user ?? null;
  if (!ready.value) ready.value = true;
});

export function useAuth() {
  const isAuthenticated = computed(() => !!session.value);
  const isAdmin = computed(() =>
    user.value?.email?.endsWith('@ridgecodetech.com') ?? false
  );

  async function signInWithPassword(email: string, password: string) {
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) throw error;
  }

  async function signOut() {
    await supabase.auth.signOut();
  }

  return { user, session, ready, isAuthenticated, isAdmin, signInWithPassword, signOut };
}
